/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { RenderElementProps } from 'slate-react';

import AssetContent from 'bundles/cml/shared/components/asset/AssetContent';
import { isVideoAssetData } from 'bundles/cml/shared/types/assetDataTypes';
import type { AssetData } from 'bundles/cml/shared/types/assetDataTypes';
import type { AssetElement } from 'bundles/cml/shared/types/elementTypes';

const styles = {
  root: css`
    position: relative;
    outline: none;
    user-select: none;
  `,
};

type Props = RenderElementProps & {
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  readonly?: boolean;
  assetData?: AssetData;
};

const getVideoProps = (assetData: AssetData) => {
  return isVideoAssetData(assetData)
    ? { videoResolutions: assetData.resolutions, subtitleTracks: assetData.subtitleTracks }
    : {};
};

const Asset = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { element, attributes, children, assetData, onClick, className, readonly = false } = props;
  const assetElement = element as AssetElement;

  return (
    <div {...attributes} className={className}>
      <div
        role={!readonly ? 'button' : undefined}
        ref={ref}
        data-e2e="slate-asset-wrapper"
        data-testid="asset-v2-wrapper"
        contentEditable={false}
        onClickCapture={onClick}
        css={styles.root}
      >
        {assetData && (
          <AssetContent
            assetData={assetData}
            assetElement={assetElement}
            {...getVideoProps(assetData)}
            readonly={readonly}
          />
        )}
      </div>
      {children}
    </div>
  );
});

Asset.displayName = 'Asset';

export default Asset;
